<template lang="html">
    <div>
        <Card>
            <template v-slot:head>
                <h5>
                    Upload manuscript <span style="color:red; font-size:16px;  margin:0;">*</span>
                </h5>
            </template>
            <template v-slot:main>
                <b-alert show variant="primary">
                    <i class="fas fa-info-circle"></i> File should be a Microsoft Word <strong>(.doc/.docx)</strong> format. See the exmpale of <strong><a>Manuscript.docx</a></strong>
                </b-alert>

                <p>Just upload your manuscript file and we will attempt to pre-populate the next steps as best we can.</p>

                <input type="file" v-on:change="upload($event)" />

                <br />
                <br />

                <div class="row">
                    <div class="col-md-12">
                        <h6>We’re parsing your manuscript…</h6>

                        <!-- Parsing manuscript -->
                        <div class="col-md-12">


                            <ul class="parse-manuscript">
                                <!-- Title -->
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for manuscript title<b> - Identified as  and prepopulated.</b>
                                </li>
                                <!-- Authors -->
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for authors (ORCIDs)<b> - Out of total authors found and prepopulated.</b>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for abstract<b> -  word abstract found </b>>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for keywords<b> -  keywords found.</b>
                                </li>
                            </ul>
                        </div>

                        <!-- Manuscript Parsed -->
                        <div class="col-md-12">
                            <ul class="parse-manuscript">
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for keywords <b> - 5 keywords found</b>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for manuscript body <b> - 4500 words found</b>
                                </li>
                                <li>
                                    <i class="fas fa-check-circle"></i>
                                    <img src="/public/images/utilities/spinner.svg"/>
                                    Looking for reviewers based on references and keywords <b> - 4 reviewers found and prepopulated</b>
                                </li>
                            </ul>
                        </div>

                    </div>

                </div>
            </template>
        </Card>
    </div>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            file: undefined
        };
    },
    methods: {
        upload(event) {
            this.file = event.target.files[0];

            let form = new FormData();
            form.append('file', this.file);

            axios.post('/api/submissions/automated', form).then(result => {
                console.log(result);
            });
        }
    },
    created() {}
}
</script>

<style lang="css" scoped>
</style>
